import React from "react";
import { Plus, Trash2 } from "lucide-react";

const inputBase =
    "w-full border border-slate-300 px-3 py-2 text-[13.5px] focus:outline-none focus:border-teal-600";

export default function StringListEdit({ value, onChange }) {
    const items = Array.isArray(value) ? value : [];

    const update = (i, v) => {
        const next = items.slice();
        next[i] = v;
        onChange(next);
    };

    const removeAt = (i) => onChange(items.filter((_, idx) => idx !== i));
    const add = () => onChange([...items, ""]);

    return (
        <div className="space-y-2">
            {items.map((it, i) => (
                <div key={i} className="flex gap-2">
                    <input
                        type="text"
                        className={inputBase}
                        value={it}
                        onChange={(e) => update(i, e.target.value)}
                    />
                    <button
                        type="button"
                        onClick={() => removeAt(i)}
                        className="px-2 border border-slate-300 text-slate-500 hover:bg-slate-50"
                    >
                        <Trash2 className="w-4 h-4" />
                    </button>
                </div>
            ))}
            <button
                type="button"
                onClick={add}
                className="inline-flex items-center gap-1 px-3 py-1.5 text-[12.5px] border border-slate-300 hover:bg-slate-50"
            >
                <Plus className="w-3.5 h-3.5" /> Add item
            </button>
        </div>
    );
}
